<template>
  <div class="container-withdrawal" :style="cssVars()">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f9f9fb;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="handleBack">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left" v-if="walletType == 0">{{ $t('lang.BaseCommon.k096') }}</span>
          <span class="tit-left" v-if="walletType == 1">{{ $t('lang.Withdrawal.k027') }}</span>
        </template>
        <template #right>
          <span class="tit-right" @click="jumpPathWithQuery('/withdrawal-details', walletType)">{{ $t('lang.BaseCommon.k074') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="main">
      <div class="head">
        <div class="head-money">
          <div class="my-balance my">
            <div class="my-balance-tit">
              <span>{{ $t('lang.BaseCommon.k102') }}</span>
              <div class="my-balance-scale">
                <img :src="getMatchImg('beans')" alt="" />
                <span>{{ beansPerDollar }} ≈</span>
                <span>{{ currencyCode }}&nbsp;</span>
                <!-- 注意精度 -->
                <span>{{ handleNumberTransformK(currencyAmountPerDollar) }}</span>
              </div>
            </div>
            <div class="my-balance-beans">
              <div class="my-beans">
                <!-- prettier-ignore -->
                <span class="beans-img">
                  <img :src="getMatchImg('beans')" alt="" />{{ beans }}
                </span>
                <!-- 注意精度 -->
                <span class="beans-tran">≈{{ currencyCode }}&nbsp;{{ handleNumberTransformK(currencyAmount) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="amount">
          <span class="tit">{{ $t('lang.Withdrawal.k025') }}</span>
          <div class="amount-num">
            <div class="price-wrapper" v-for="(item, index) in moneyList" :key="index">
              <div
                class="price"
                :class="{
                  'price-active': Number(priceActive) == item,
                  'on-selece-price': minPrice && item < minPrice,
                }"
                @click="handleChoose(item)"
              >
                <i v-if="item">
                  {{ item * 10 }}
                  <img :src="getMatchImg('beans')" alt="" width="16" />
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bind">
        <div class="method account" @click="handleToBindAccound(walletType, locaFlag, locaCode, withdrawAccounts, priceActive)">
          <div class="number">
            <img src="@/assets/packageAssets/views/P1_Girls/Withdrawal/default/dollar.png" alt="" />
            <span>{{ $t('lang.BaseCommon.k106') }}</span>
          </div>
          <div class="arrow">
            <div class="arrow-box">
              <i v-if="!withdrawalMethod">{{ $t('lang.BaseCommon.k004') }}</i>
              <div v-else class="bind-accound">
                <img :src="icon | imgPath" alt="" />
                <i>{{ withdrawalMethod }}</i>
              </div>
              <van-icon class="arrow-icon" name="arrow" />
            </div>
          </div>
        </div>
        <!-- 只有Pix和Paypal的时候才会不显示这个费率 -->
        <div class="fee-usdt" v-if="withdrawalMethod && !(withdrawalMethod == 'PIX')">
          {{ (feeUsdtMap[priceActive] || [])[0] || 'Fee 2%' }}
        </div>
      </div>
      <!-- 先验证是否此人被封禁handleIsVerify  再提现withdrawApply  -->
      <div
        :class="['withdraw-btn', priceActive && withdrawalMethod && priceActive * 10 <= beans ? 'withdraw-atc' : '']"
        @click="handleDialogClickWithdraw"
      >
        {{ $t('lang.BaseCommon.k096') }}
      </div>
      <div class="withdraw-rules">
        <span>{{ $t('lang.Withdrawal.k017') }}</span>
        <div>
          <span>1. {{ $t('lang.Withdrawal.k020') }}</span>
          <span>&nbsp;{{ minBeansPerDollar }}&nbsp;</span>
          <span>{{ $t('lang.Withdrawal.k018') }}</span>
        </div>
        <div>
          <span>2. {{ $t('lang.Withdrawal.k021') }}</span>
        </div>
        <div>
          <span>3. {{ $t('lang.Withdrawal.k022') }}</span>
          <span v-if="walletType == 0" class="immediately" @click="handleToImmediately">{{ $t('lang.Withdrawal.k019') }}</span>
        </div>
        <div>4. {{ $t('lang.Withdrawal.k023') }}</div>
        <div>5. {{ $t('lang.Withdrawal.k024') }}</div>
      </div>
    </div>

    <!-- 确认框 -->
    <van-dialog v-if="showDialog" v-model="showDialog" :showConfirmButton="false">
      <div class="dialog">
        <div class="title">{{ $t('lang.Withdrawal.k013') }}</div>
        <ul style="width: 100%">
          <!-- Amount -->
          <li class="amount-li">
            <span>{{ $t('lang.BaseCommon.k054') }}：</span>
            <!-- 注意精度 -->
            <template v-if="withdrawalMethod === 'USDT(TRC20)' || withdrawalMethod === 'USDT(TRC20/BEP20)' || withdrawalMethod === 'USDT(BINANCE)'">
              <i>≈USDT {{ returnFloat(myDiv(myTimes(priceActive, 10), beansPerDollar)) }}</i>
            </template>
            <template v-else>
              <i>
                ≈{{ currencyCode }}{{ returnFloat(myTimes(myDiv(myTimes(priceActive, 10), beansPerDollar), myDiv(currencyAmountPerDollar, 100))) }}
              </i>
            </template>
          </li>

          <!-- Method -->
          <li class="method-li">
            <span>{{ $t('lang.BaseCommon.k058') }}：</span>
            <img :src="icon | imgPath" alt="" />
            <i>{{ withdrawalMethod }}</i>
          </li>

          <!--
            Fee 和 Arrival Amount
            非PIX-提现类型
          -->
          <template v-if="withdrawalMethod && withdrawalMethod !== 'PIX'">
            <!-- Fee -->
            <li class="amount-li">
              <span>{{ $t('lang.BaseCommon.k057') }}：</span>
              <i>{{ feeUsdt == '0.000' ? currencyCode + handelFeeTax(feeTax, currencyAmountPerDollar) : +feeUsdt * 100 + '%' }}</i>
            </li>
            <!-- Arrival Amount -->
            <li class="amount-li">
              <span>{{ $t('lang.BaseCommon.k055') }}：</span>
              <!-- 注意精度 -->
              <template v-if="withdrawalMethod === 'USDT(TRC20)' || withdrawalMethod === 'USDT(TRC20/BEP20)' || withdrawalMethod === 'USDT(BINANCE)'">
                <i>≈USDT {{ returnFloat(myTimes(myDiv(myMinus(myTimes(priceActive, 10), feeTax), beansPerDollar), myMinus(1, feeUsdt))) }}</i>
              </template>
              <!-- prettier-ignore -->
              <template v-else>
                <i>
                  ≈{{ currencyCode }}{{ returnFloat(myTimes(myTimes(myDiv(myMinus(myTimes(priceActive, 10), feeTax), beansPerDollar), myDiv(currencyAmountPerDollar, 100)), myMinus(1, feeUsdt))) }}
                </i>
              </template>
            </li>
          </template>

          <!-- Account -->
          <li class="account-li account-box">
            <span v-if="withdrawalMethod == 'USDT(TRC20)' || withdrawalMethod == 'USDT(TRC20/BEP20)'" type="text">
              {{ $t('lang.BaseCommon.k099') }}:
            </span>
            <span v-else>{{ $t('lang.BaseCommon.k103') }}：</span>
            {{ withdrawAccount }}
          </li>

          <!--
            Address
            USDT(BINANCE)-提现类型
          -->
          <template v-if="withdrawalMethod === 'USDT(BINANCE)' && accountAddress">
            <li class="method-li">
              <span>{{ $t('lang.BaseCommon.k100') }}：</span>
              <div class="account-address-text">{{ accountAddress }}</div>
            </li>
          </template>
        </ul>
        <div class="btn">
          <span @click="handleThinK">{{ $t('lang.BaseCommon.k098') }}</span>
          <span @click="handleConfirm" class="confirm-btn">{{ $t('lang.BaseCommon.k028') }}</span>
        </div>
      </div>
    </van-dialog>

    <!-- 升级版本确认框 -->
    <c-update :showDiaUp="showDiaUp" :title="titleConfirmUp"></c-update>

    <!-- 二次确认框 -->
    <van-dialog v-model="showDiaConfirm" :showConfirmButton="false" :closeOnClickOverlay="true" @close="cancelAgain">
      <div class="confirm-dialog-wrapper">
        <div class="headline" v-if="headline">{{ headline }}</div>
        <div class="title">{{ titleConfirm }}</div>
        <div class="btn">
          <div @click="jumpPathWithQuery('/withdrawal-details', walletType)" class="confirm-btn">
            {{ $t('lang.BaseCommon.k056') }}
          </div>
          <div @click="cancelAgain" class="confirm-think">{{ $t('lang.BaseCommon.k019') }}</div>
        </div>
      </div>
    </van-dialog>

    <!-- 进入页面就打来这个新年公告 -->
    <!-- 提现报错之后也用弹框提示，因为客户端用的会把提示消息截断 显示不全 -->
    <confirm-dia :con="con" :showDia="showDia"></confirm-dia>

    <!-- 优质用户弹窗 -->
    <van-dialog v-model="popupVisible" title="" :showConfirmButton="false" :showCancelButton="false" width="300">
      <div class="dialog-wrapper">
        <div class="content">
          <p>
            <span>{{ $t('lang.Withdrawal.k026') }}</span>
            <img :src="getMatchImg('beans')" alt="coin" width="24" height="24" />
          </p>
        </div>
        <div class="fonter-wrapper">
          <div class="confirm-btn withdraw-atc" @click="handleDialogClickWithdraw">
            {{ $t('lang.BaseCommon.k096') }}
          </div>
          <div @click="popupVisible = false">{{ $t('lang.BaseCommon.k019') }}</div>
        </div>
      </div>
    </van-dialog>

    <!-- 用户未实名弹窗 -->
    <van-dialog v-model="showNoAuthDia" title="" :showConfirmButton="false" :showCancelButton="false" width="300">
      <div class="dialog-wrapper">
        <div class="title">{{ $t('lang.BaseCommon.k069') }}</div>
        <div class="content">
          <p>
            <span>{{ $t('lang.BaseCommon.k014') }}</span>
          </p>
        </div>
        <div class="fonter-wrapper">
          <div class="confirm-btn withdraw-atc" @click="toUserVerify">{{ $t('lang.BaseCommon.k015') }}</div>
          <div @click="showNoAuthDia = false">{{ $t('lang.BaseCommon.k019') }}</div>
        </div>
      </div>
    </van-dialog>

    <!-- 提现失败提示弹框 -->
    <van-dialog v-model="showNotApprovedDialog" :showConfirmButton="false">
      <div class="dialog not-approved-dialog">
        <div class="title">{{ $t('lang.Withdrawal.k001') }}</div>

        <div class="not-approved-content">
          <div class="info-item">
            <div class="item-title">{{ $t('lang.BaseCommon.k058') }}</div>
            <div class="item-value">{{ notApprovedInfo.withdrawMethod || '-' }}</div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.BaseCommon.k054') }}</div>
            <div class="item-value purple">
              {{
                notApprovedInfo.applyAmount
                  ? `≈${notApprovedInfo.currency}
              ${handleUSDollar(notApprovedInfo.applyAmount)}`
                  : '-'
              }}
            </div>
          </div>
          <div class="info-item">
            <div class="item-title">{{ $t('lang.BaseCommon.k059') }}</div>
            <div class="item-value">{{ notApprovedInfo.createTime ? handleMoment(notApprovedInfo.createTime, 'DD/MM/YYYY HH:mm:ss') : '-' }}</div>
          </div>
        </div>

        <div class="btn">
          <span class="confirm-btn" @click="handleViewDetail">{{ $t('lang.BaseCommon.k056') }}</span>
          <span class="later-btn" @click="handleCommonSure('showNotApprovedDialog')">{{ $t('lang.BaseCommon.k019') }}</span>
        </div>
      </div>
    </van-dialog>

    <!-- USDT(BINANCE) off 已绑定,未填写链地址 -->
    <van-dialog v-model="showUsdtBinanceOff1" :showConfirmButton="false">
      <div class="dialog not-approved-dialog">
        <div class="title">{{ $t('lang.Withdrawal.k002') }}</div>

        <p>{{ $t('lang.Withdrawal.k003') }}</p>

        <div class="btn">
          <span class="confirm-btn" @click="handleToEdit">{{ $t('lang.Withdrawal.k004') }}</span>
          <span class="later-btn" @click="handleCommonSure('showUsdtBinanceOff1')">{{ $t('lang.BaseCommon.k019') }}</span>
        </div>
      </div>
    </van-dialog>

    <!-- USDT(BINANCE) off 已绑定,已填写链地址 -->
    <van-dialog v-model="showUsdtBinanceOff2" :showConfirmButton="false">
      <div class="dialog not-approved-dialog">
        <div class="title">{{ $t('lang.Withdrawal.k002') }}</div>

        <p>{{ $t('lang.Withdrawal.k005') }}</p>

        <div class="btn">
          <span class="confirm-btn" @click="handleCommonSure('showUsdtBinanceOff2')">{{ $t('lang.BaseCommon.k088') }}</span>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { apiWithdrawPage, apiWithdrawApply, apiWithdrawVerify, apiFetchUserAccountInfo } from '@/api/imee'
import { apiWithdrawCheckData, apiNewyearDiaShowTime } from '@/api/withdraw.js'
import { getUTCTime } from '@/utils/public.js'
import { pageCssVars } from './z-style-cfg.js'

import _debounce from 'lodash/debounce'

import CUpdate from '@/components/CUpdate'
import ConfirmDia from '@/components/CConfirmDia'

export default {
  mixins: [pageCssVars],
  components: { CUpdate, ConfirmDia },
  props: {},
  data() {
    const localData = JSON.parse(sessionStorage.getItem('bind-withdrawal') || '{}')
    const query = this.$route.query
    return {
      queryData: query,
      barHeight: query.statusBarHeight || 38,
      titleConfirm: this.$t('lang.Withdrawal.k014'),
      headline: this.$t('lang.Withdrawal.k015'),
      active: false,
      moneyList: [],
      priceActive: localData.price || query.price || '',
      showDialog: query.showDialog || false,
      showDiaConfirm: false,
      showDia: false,
      con: '',
      oneShow: false,
      // 钱包类型  0主播  1是代理
      walletType: localData.walletType || query.walletType || 0,
      balance: 0,
      beans: 0,
      withdrawAccount: null,
      locaFlag: '',
      locaCode: '',
      cfgId: localData.withdrawalMethod || query.withdrawalMethod || null,
      // 已经绑定的账号
      withdrawAccounts: null,
      feeUsdt: 0,
      feeUsdtMap: [],
      feeTax: 0,
      withdrawalMethod: localData.withdrawalMethod || query.withdrawalMethod || null, // 支付方式
      icon: localData.icon || query.icon || null, // 支付方式图片
      minPrice: localData.minPrice || query.minPrice || null, // 根据选择的方式 能选择的最小金额
      bindFlag: null,
      isVerify: false,
      // 提示升级
      showDiaUp: false,
      titleConfirmUp: '',

      applyFlag: false, // 提现接口 节流阀

      currencyAmount: null,
      currencyAmountPerDollar: null,
      currencyCode: null,
      accountAddress: '',
      beansPerDollar: 1000, // 右上角的兑换数量
      minBeansPerDollar: 10000, // 规则里面的 10000，要展示上面六个档位里面的最小的那个
      popupVisible: false,
      withdrawAccountNotFound: false, // 提现账号不存在
      // 用户未实名弹框
      showNoAuthDia: false,

      // 弹框stack
      dialogStack: [],
      // 0 提现失败弹框
      showNotApprovedDialog: false,
      notApprovedInfo: {
        applyAmount: null,
        createTime: null,
        currency: '',
        withdrawMethod: ''
      },
      // 1 已绑定USDT(BINANCE)提现方式，但未填写链地址
      showUsdtBinanceOff1: false,
      // 2 已绑定USDT(BINANCE)提现方式，已填写链地址
      showUsdtBinanceOff2: false,

      cacheWithdrawMethods: null
    }
  },
  computed: {
    // 美分转美元
    handleUSDollar() {
      return (amount) => {
        if (amount === 0) {
          return amount
        } else {
          return (amount / 100).toFixed(2)
        }
      }
    }
  },
  methods: {
    handelFeeTax(num1, num2) {
      return Math.round((num1 / 100) * (num2 / 100))
    },
    handleBack() {
      const query = this.$route.query
      if (query.fromPage && query.fromPage == 'income') {
        this.$router.replace({
          path: '/invite',
          query: {
            tab: 2
          }
        })
        return
      }
      if (query.fromPage && query.fromPage == 'my-beans') {
        this.$router.replace({
          path: '/my-beans',
          query: {
            tab: 2
          }
        })
        return
      }

      if (query.fromPage && query.fromPage == 'invite-v2') {
        this.goPrevious()
        return
      }

      this.closeWeb()
    },

    // 获取限制时间
    newyearDiaShowTime() {
      apiNewyearDiaShowTime().then((res) => {
        if (res) {
          this.showNewYearDiaFlag = res.needShow // 是否显示弹框
          const start = +res.notifyStartTime
          const end = +res.notifyEndTime
          const now = +getUTCTime()
          if (now > start && now < end) {
            this.noticeBarFlag = true
          } else {
            this.noticeBarFlag = false
          }
        }
      })
    },
    // 获取主页数据  0主播  1是代理
    handleWithdrawPage(afterFn) {
      apiWithdrawPage(this.walletType, this.withdrawalMethod || '').then((res) => {
        if (res && !res.error) {
          try {
            // 获取右上角豆子兑换额度
            this.beansPerDollar = res.beansPerDollar || 1000
            // 获取豆子列表
            this.moneyList = res && res.listWithdrawDollarsAmounts
            // 获取最低豆子兑换额度
            this.minBeansPerDollar = ((this.moneyList || [])[0] || 1000) * 10
            if (res.listWithdrawDollarsAmounts && res.listWithdrawDollarsAmounts.length > 0) {
              const queryPrice = this.priceActive || ''
              if ((res.listWithdrawDollarsAmounts || []).findIndex((v) => v === queryPrice) > -1) {
                this.priceActive = queryPrice
              } else {
                this.priceActive = res.listWithdrawDollarsAmounts[0]
              }
            }
            this.currencyAmount = res.currencyAmount
            this.currencyAmountPerDollar = res.currencyAmountPerDollar
            this.currencyCode = res.currencyCode

            this.balance = res.dollarsAmount * 0.01
            this.balance = Math.round(this.balance * 100) / 100
            this.beans = res.beansAmount
            this.withdrawAccounts = res.withdrawAccounts
            this.cacheWithdrawMethods = res.withdrawMethods
            this.fetchWithdrawAccount(res.withdrawAccounts)
            let list = []
            if (this.withdrawalMethod) {
              if (!(this.withdrawalMethod == 'PIX')) {
                res.withdrawMethods.forEach((item) => {
                  if (item.withdrawalMethod == this.withdrawalMethod) {
                    list = item.withdrawDollarsList
                  }
                })
                list.forEach((item) => {
                  this.feeUsdtMap[item.dollarAmount] = [item.feeDesc, item.feeRate, item.feeTax]
                })
                const arr = this.feeUsdtMap[this.moneyList[0]] || []
                this.feeUsdt = ((this.feeUsdtMap || [])[this.priceActive] || [])[1] || arr[1] || 0
                this.feeTax = ((this.feeUsdtMap || [])[this.priceActive] || [])[2] || arr[2] || 0
              }
            }
            if (res.canWithdraw5Dollar) {
              this.popupVisible = true
            }

            if (res.notifies && res.notifies.length) {
              res.notifies.forEach((notifyItem) => {
                this.dialogStack.push({
                  ...notifyItem
                })
              })
            }

            this.flushDialogStack()

            afterFn && afterFn()
          } catch (err) {
            console.log('try catch', err)
          }
        }
      })
    },
    // 跳转到绑定账号页面
    handleToBindAccound(walletType, locaFlag, locaCode, withdrawAccounts, price) {
      this.$router.push({
        path: '/bind-withdrawal',
        query: {
          walletType,
          locaFlag,
          locaCode,
          accounts: JSON.stringify(withdrawAccounts),
          price
        }
      })
    },
    // 选择
    handleChoose(val) {
      if (!this.withdrawAccount) {
        this.$client.showToast(this.$t('lang.Withdrawal.k012'))
        return
      }
      this.priceActive = val
      this.feeUsdt = +((this.feeUsdtMap || [])[val] || [])[1]
    },

    // withdraw按钮 先判断是否封禁
    withdrawApply() {
      if (this.priceActive * 10 > this.beans) {
        this.$client.showToast(this.$t('lang.Withdrawal.k016'))
        return
      }
      this.withdrawCheckData()
    },

    // 提现前跳转到check页面  true为需要审核  false为不需要审核
    withdrawCheckData() {
      apiWithdrawCheckData(this.walletType).then((res) => {
        if (res && res.ifNeedCheck == true) {
          // 跳转到检查页面
          this.$router.replace({
            path: '/check-performance',
            query: {
              walletType: this.walletType,
              price: this.priceActive,
              conditions: JSON.stringify(res.conditions),
              remainCheckTimes: res.remainCheckTimes,
              withdrawalMethod: this.withdrawalMethod,
              icon: this.icon
            }
          })
        } else {
          this.showDialog = true
        }
      })
    },

    // 提现之前判断是否封禁
    handleIsVerify: _debounce(
      function () {
        const data = {
          accountCfgId: this.cfgId,
          dollarsAmount: this.priceActive,
          withdrawalMethod: this.withdrawalMethod
        }
        apiWithdrawVerify(data, this.walletType).then((res) => {
          if (res.status == 200) {
            this.withdrawApply()
          }
          // 异常状态
          else {
            this.withdrawAccountNotFound = false

            // 主播未实名认证
            if (res.error.status == 692 && this.walletType == 0) {
              this.showNoAuthDia = true
              return
            }

            if (res.error.status == 694) {
              this.titleConfirmUp = res.error.description
              this.showDiaUp = true
              return
            }

            if (res.error.status == 693) {
              this.withdrawAccountNotFound = true
            }

            this.headline = null
            this.con = res.error.description
            this.showDia = true
          }
        })
      },
      2000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 关闭确认消息框
    closeDia() {
      this.showDia = false
      if (this.withdrawAccountNotFound) {
        this.handleToBindAccound(this.walletType, this.locaFlag, this.locaCode, this.withdrawAccounts, this.priceActive)
      }
    },

    // 取消
    handleThinK() {
      this.showDialog = false
    },
    // 确认
    handleConfirm() {
      this.handleWithdrawApply()
      this.oneShow = true // 二次确认弹框 只展示一个按钮
    },

    //  二次确认框 取消
    cancelAgain() {
      this.showDialog = false
      this.showDiaConfirm = false
      this.showDiaUp = false
    },
    // // 二次确认弹框
    confirmCon() {},

    // 取消升级
    upCancel() {
      this.showDiaUp = false
    },
    // 确认升级
    confirmUp() {
      const url = 'https://play.google.com/store/apps/details?id=com.client.goparty'
      window.open(url, '_blank')
    },
    // 获取用户信息
    fetchUserAccountInfo() {
      apiFetchUserAccountInfo().then((res) => {
        this.locaCode = res.locationCode
        this.locaFlag = res.locationFlag
      })
    },
    // 获取提现账户方式
    fetchWithdrawAccount(res) {
      if (res && res.length != 0) {
        if (!this.withdrawalMethod && !this.icon) {
          this.withdrawAccount = res[0].accountId
          this.cfgId = res[0].cfgId
          this.withdrawalMethod = res[0].withdrawalMethod
          this.icon = res[0].withdrawalMethodIcon
          this.minPrice = res[0].minDollarAmount
          this.accountAddress = (res[0] || {}).accountAddress || ''
        } else {
          res.forEach((item) => {
            if (item.withdrawalMethod == this.withdrawalMethod) {
              this.withdrawAccount = item.accountId
              this.cfgId = item.cfgId
              this.withdrawalMethod = item.withdrawalMethod
              this.icon = item.withdrawalMethodIcon
              this.minPrice = item.minDollarAmount
              this.accountAddress = (item || {}).accountAddress || ''
            }
          })
        }
      }
    },
    // 跳转到提现详情页面
    jumpPathWithQuery(path, walletType) {
      this.$router.push({
        path,
        query: {
          walletType
        }
      })
    },

    // 申请提现
    handleWithdrawApply() {
      const data = {
        accountCfgId: this.cfgId,
        dollarsAmount: this.priceActive
      }
      this.applyFlag = true
      if (this.applyFlag) {
        apiWithdrawApply(data, this.walletType).then((res) => {
          if (res.error && res.error.status !== 200) {
            this.titleConfirm = res.error.description
            this.headline = null
            this.showDialog = false
            this.showDiaConfirm = true
          }
          if (res.status == 200) {
            this.showDialog = false
            this.showDiaConfirm = true
            this.handleWithdrawPage()
          }
          this.applyFlag = false
        })
      }
    },

    // 保留两位小数
    returnFloat(num) {
      if (num === undefined || num === null || num === '') {
        return '0.00'
      }
      // 转成字符串类型
      num = num.toString()
      // 整数
      if (num.indexOf('.') !== -1) {
        let [integerPart, decimalPart] = num.split('.')
        if (decimalPart.length > 2) {
          decimalPart = decimalPart.substring(0, 2)
        }
        if (decimalPart.length === 1) {
          decimalPart += '0'
        }
        num = `${integerPart}.${decimalPart}`
      }
      // 非整数
      else {
        num += '.00'
      }
      return num
    },
    // 印尼的则转成K
    handleNumberTransformK(num) {
      if (num === null || num === undefined) {
        return ''
      }
      if (typeof num !== 'number' && typeof num !== 'string') {
        return 'NaN'
      }
      if (num == 0) {
        return '0'
      }

      num = num / 100

      // 印尼地区
      if (this.locaCode === 'ID') {
        const myNum = num * 1
        const kValue = Math.floor((myNum / 1000) * 100) / 100
        // 整数-不处理
        if (Number.isInteger(kValue)) {
          return `${kValue}K`
        }
        // 小数-保留2位
        else {
          return `${kValue.toFixed(2)}K`
        }
      }
      // 其他地区
      else {
        return this.returnFloat(num)
      }
    },
    // 弹窗里点击提现
    handleDialogClickWithdraw() {
      this.popupVisible = false
      if (!this.withdrawAccount || !this.priceActive) {
        return this.$client.showToast(this.$t('lang.Withdrawal.k012'))
      }
      if (this.priceActive && this.withdrawalMethod && this.priceActive * 10 <= this.beans) {
        this.handleIsVerify()
      }
    },
    /**
     * @description 修改Url
     * @description 参数覆盖 和 新增
     */
    handleChangeQueryParams(obj) {
      if (Object.keys(obj).length <= 0) return
      // 获取当前URL
      const urlArr = window.location.href.split('?') || []
      let queryString1 = urlArr[0] || ''
      const queryString2 = urlArr[1] || ''
      const paramsObj = {}
      if (queryString2 !== '') {
        queryString2.split('&').forEach((keyValuePair) => {
          const [key, value] = keyValuePair.split('=')
          paramsObj[key] = value || ''
        })
      }
      const finalObject = { ...paramsObj, ...obj }
      Object.keys(finalObject).forEach((item, index) => {
        if (index === 0) {
          queryString1 += `?${item}=${finalObject[item]}`
        } else {
          queryString1 += `&${item}=${finalObject[item]}`
        }
      })
      history.replaceState(null, null, queryString1)
    },
    /**
     * @description 前往快速体现说明
     */
    handleToImmediately() {
      this.$router.push({
        path: 'instant-payment',
        query: {}
      })
    },
    handleViewDetail() {
      if (this.notApprovedInfo && this.notApprovedInfo.withdrawId) {
        this.$router.push({
          path: 'withdrawal-details-status',
          query: {
            withdrawId: this.notApprovedInfo.withdrawId
          }
        })
      }
    },
    toUserVerify() {
      this.appAction('open_user_verify_page')
    },
    flushDialogStack() {
      if (this.dialogStack && this.dialogStack.length) {
        const dialogTask = this.dialogStack.shift()
        if (dialogTask) {
          const type = dialogTask.type
          switch (type) {
            case 0:
              this.showNotApprovedDialog = true
              this.notApprovedInfo = Object.assign(this.notApprovedInfo, dialogTask)
              break
            case 1:
              this.showUsdtBinanceOff1 = true
              break
            case 2:
              this.showUsdtBinanceOff2 = true
              break
          }
        }
      }
    },
    handleCommonSure(arg) {
      this[arg] = false
      this.flushDialogStack()
    },
    handleToEdit() {
      const targetObj = this.cacheWithdrawMethods.find((item) => item.withdrawalMethod === 'USDT(BINANCE)')
      if (targetObj) {
        this.$router.push({
          path: 'withdrawal-account',
          query: {
            locaFlag: this.locaFlag,
            locaCode: this.locaCode,
            walletType: this.walletType,
            icon: targetObj.icon,
            withdrawalMethod: targetObj.withdrawalMethod,
            minDollarAmount: null,
            change: true
          }
        })
      }
    }
  },
  created() {
    const localData = JSON.parse(sessionStorage.getItem('bind-withdrawal') || '{}')
    this.handleChangeQueryParams(localData)
    sessionStorage.removeItem('bind-withdrawal')

    this.handleWithdrawPage()
    this.fetchUserAccountInfo()
    this.fetchWithdrawAccount()
  }
}
</script>

<style lang="scss" scoped>
.container-withdrawal {
  width: 100%;
  min-height: 100vh;
  background: var(--wd-page-bg);

  /* 主内容 */
  .main {
    margin-top: 20px;
    padding: 0 14px;
    .head {
      width: 100%;
      .head-money {
        width: 100%;
        padding: 16px 24px;
        position: relative;
        z-index: 100;
        margin: 0 auto;
        border-radius: 12px 12px 0 0;
        background: var(--wd-balance-gradient);
        .my-balance {
          font-family: 'Inter-Regular';
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          .my-balance-tit {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }
          .my-balance-scale {
            display: flex;
            align-items: center;
            color: #ffd000;
            > img {
              width: 14px;
              height: 14px;
              margin: 0 2px;
            }
          }
          .my-balance-beans {
            display: flex;
            flex-wrap: wrap;
            width: 100%;

            font-weight: 500;
            margin-top: 8px;
            font-family: 'Inter-Regular';
            .my-beans {
              width: 100%;
              font-size: 30px;
              word-wrap: break-word;
              .beans-img {
                display: inline-block;
                > img {
                  width: 26px;
                  height: 26px;
                  vertical-align: middle;
                  margin: 0 1px;
                }
              }
              .beans-tran {
                display: inline-block;
                padding-bottom: 2px;
                font-size: 20px;
                font-weight: 400;
                color: #ffffff;
              }
            }
          }
        }
      }
      .amount {
        position: relative;
        z-index: 50;
        width: 100%;
        min-height: 173px;
        margin: 0 auto;
        background: #ffffff;
        border-radius: 0 0 12px 12px;
        padding: 20px 20px 25px;
        .tit {
          display: block;
          font-size: 17px;
          font-family: 'Inter-Regular';
          font-weight: 500;
          color: #333333;
        }
        .amount-num {
          width: 100%;
          padding-top: 20px;
          overflow: hidden;
        }
        .price-wrapper {
          float: left;
          width: calc((100% - 24px) / 3);
          height: 40px;
          margin-top: 16px;
          margin-left: 12px;
          .price {
            i {
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 14px;
                margin: 0 2px;
              }
            }
          }
          &:nth-child(1) {
            margin-top: 0;
          }
          &:nth-child(2) {
            margin-top: 0;
          }
          &:nth-child(3) {
            margin-top: 0;
          }
          &:nth-child(3n + 1) {
            margin-left: 0;
          }
        }
        .price {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          background: #f9f9fb;
          border-radius: 4px;
          text-align: center;
          font-size: 14px;
          font-family: 'Inter-Regular';
          font-weight: 500;
          color: #666666;
          border: 1px solid #f9f9fb;
        }
        .price-active {
          background: var(--wd-price-active-bg);
          border: 1px solid var(--wd-price-active-border);
          color: var(--wd-price-active-color);
        }
        .on-selece-price {
          filter: grayscale(100%);
          pointer-events: none;
          background-color: #f1f3f4;
          color: #fff;
        }
      }
    }
    .bind {
      position: relative;
      width: 100%;
      // height: 107px;
      margin: 20px auto 0;
      background: #ffffff;
      border-radius: 12px;
      padding: 0 17px;
      .phone {
        border-bottom: 0.5px solid #f4f4f4;
      }
      .account {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 18px 0;
        // height: 54px;
        > .number {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: 'Inter-Medium';
          font-weight: 500;
          color: #333333;
          > img {
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }
        }
        > .arrow {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-family: 'Inter-Regular';
          font-weight: 400;
          color: #999999;
          .arrow-icon {
            font-size: 14px;
            padding-left: 5px;
          }
        }
        .arrow-box {
          display: flex;
          align-items: center;
        }
        .bind-accound {
          display: flex;
          align-items: center;
          > img {
            height: 20px;
          }
        }
      }

      .fee-usdt {
        padding: 0 5px;
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        background-color: var(--wd-fee-badge-bg);
        border-radius: 0 8px 0 8px;
        text-align: center;
        line-height: 15px;

        font-family: 'Inter-Regular';
        font-weight: 400;
        font-size: 10px;
        color: #ffffff;
      }
    }

    .withdraw-btn {
      width: 289px;
      margin: 40px auto;
      padding: 12px 0;
      background: #e1e1e1;
      border-radius: 20px;
      font-size: 16px;
      font-family: 'Inter-Medium';
      font-weight: 500;
      color: #ffffff;
      text-align: center;

      &.withdraw-atc {
        background: var(--wd-theme-color);
        color: var(--wd-theme-btn-color);
        pointer-events: auto;
      }
    }

    .withdraw-rules {
      font-size: 12px;
      font-family: 'Inter-Regular';
      font-weight: 400;
      color: #999999;
      padding-bottom: 16px;
      > span {
        display: block;
        margin-bottom: 10px;
        font-size: 14px;
        font-family: 'Inter-Bold';
        font-weight: 600;
        color: #666666;
      }
      > div {
        margin-bottom: 8px;
      }

      .immediately {
        color: var(--wd-immediately-color) !important;
        cursor: pointer;
      }
    }
  }

  /* 确认弹窗 */
  .dialog {
    width: 300px;
    background: #ffffff;
    border-radius: 12px;
    padding: 20px 20px;
    margin: 0 auto;

    .title {
      font-size: 16px;
      font-family: 'Inter-Medium';
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      text-align: center;
      margin-bottom: 20px;
    }
    ul {
      font-size: 14px;
      font-family: 'Inter-Regular';
      font-weight: 400;
      color: #666666;
      li {
        display: block;
        margin-bottom: 10px;
        > span {
          color: #333333;
        }
      }
      .amount-li {
        > i {
          color: var(--wd-dialog-amount-color);
          font-family: 'Inter-Medium';
          font-weight: 500;
        }
      }
      .method-li {
        display: flex;
        align-items: center;
        font-family: 'Inter-Regular';
        > span {
          display: block;
        }
        > img {
          display: block;
          height: 20px;
        }
        > i {
          display: block;
          font-weight: 500 !important;
          color: #000 !important;
          font-family: 'Inter-Medium';
        }

        .account-address-text {
          width: 160px !important;
          white-space: normal !important;
          font-weight: 500;
          color: #000000;
          font-size: 12px !important;
          line-height: 16px !important;
          overflow-wrap: break-word !important;
        }
      }
      .account-li {
        font-family: 'Inter-Regular';
        > span:nth-child(2) {
          font-weight: 500 !important;
          color: #000 !important;
          font-family: 'Inter-Medium';
        }
      }
      .account-box {
        font-weight: 500 !important;
        color: #000;
        word-wrap: break-word;
        > span {
          font-weight: 400;
          color: #333;
        }
      }
    }

    .btn {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;

      > span {
        display: block;
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #e1e1e1;
        border-radius: 20px;
        font-size: 16px;
        font-family: 'Inter-Bold';
        font-weight: 600;
        color: #ffffff;
      }
      .confirm-btn {
        background: var(--wd-theme-color);
        color: var(--wd-theme-btn-color);
        margin-left: 10px;
      }
    }

    &.not-approved-dialog {
      padding: 20px 6px;

      .not-approved-content {
        padding-top: 4px;

        .info-item {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          width: 100%;
          height: min-content;
          padding-bottom: 24px;
          &:last-child {
            padding-bottom: 0;
          }
          .item-title {
            width: fit-content;
            flex-grow: 0;
            font-family: 'Roboto-Regular';
            font-weight: 400;
            font-size: 15px;
            color: #999999;
            line-height: 18px;
            text-align: left;
            font-style: normal;
            padding-right: 10px;
          }
          .item-value {
            flex-grow: 1;
            font-family: 'Roboto-Regular';
            font-weight: 400;
            font-size: 15px;
            color: #333333;
            line-height: 18px;
            text-align: right;
            font-style: normal;
            word-break: break-word;
          }
          .purple {
            color: var(--wd-theme-color) !important;
          }
        }
      }

      .btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .later-btn,
        .confirm-btn {
          display: block;
          width: 283px;
          height: 48px;
          line-height: 48px;
          border-radius: 24px;
          margin: 0 auto;
          font-family: 'Roboto-Regular';
          font-size: 15px;
          font-weight: normal;
          margin-left: 0;
        }
        .later-btn {
          border: 1px solid var(--wd-theme-color);
          color: var(--wd-theme-color);
          background-color: transparent;
          margin-top: 16px;
        }
      }
    }
  }

  /* 轻提示类弹窗 */
  .dialog-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: 300px;
    height: 200px;
    background-color: #fff;
    border-radius: 16px;
    overflow: hidden;
    font-weight: normal;
    padding: 20px;
    .title {
      font-size: 16px;
      font-family: 'Inter-Medium';
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      text-align: center;
    }
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 100px;
      color: #000;
      img {
        vertical-align: bottom;
      }
    }
    .fonter-wrapper {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      > div {
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border-radius: 20px;
        font-size: 14px;
        font-family: 'Inter-Bold';
        color: var(--wd-theme-color);
        font-weight: 600;
        border: 1px solid var(--wd-theme-color);
      }
      .confirm-btn {
        background-color: #cccccc;
        margin-right: 10px;
        pointer-events: none;
        border-color: #cccccc !important;
        color: #ffffff !important;
      }
      .withdraw-atc {
        background-color: var(--wd-theme-color) !important;
        pointer-events: auto;
        color: #ffffff !important;
      }
    }
  }

  /* 二次确认弹窗 */
  .confirm-dialog-wrapper {
    width: 315px;
    max-width: 100%;
    background: #ffffff;
    border-radius: 12px;
    padding: 25px 20px 20px 20px;
    margin: 0 auto;
    .headline {
      width: 100%;
      text-align: center;
      font-weight: 600;
      font-size: 17px;
      color: #333333;
      line-height: 20px;
    }
    .title {
      font-weight: 400;
      font-size: 15px;
      color: #333333;
      line-height: 18px;
      font-family: 'Inter-Medium', 'Inter-Regular';
      text-align: start;
      margin: 10px 0;
    }
    .btn {
      width: 100%;
      height: fit-content;
      padding-top: 10px;
      .confirm-btn {
        width: 100%;
        height: 48px;
        background-color: var(--wd-theme-color);
        border-radius: 24px;
        overflow: hidden;
        font-size: 15px;
        color: var(--wd-theme-btn-color);
        line-height: 48px;
        text-align: center;
        margin-bottom: 16px;
        cursor: pointer;
      }
      .confirm-think {
        width: 100%;
        height: 48px;
        background-color: #ffffff;
        border: 1px solid var(--wd-theme-color);
        border-radius: 24px;
        overflow: hidden;
        font-size: 15px;
        color: var(--wd-theme-color);
        line-height: 48px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

/* RTL 与导航（与模板树一致） */
html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-withdrawal {
    .main .bind .fee-usdt {
      position: absolute;
      right: auto !important;
      left: 0 !important;
      border-radius: 8px 0 8px 0 !important;
    }

    .custom-nav-block .van-bar {
      .van-nav-bar__content {
        .van-nav-bar__right {
          .tit-right {
            padding-left: 0;
            padding-right: 30px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
/* 穿透 Vant NavBar，与 .custom-nav-block 树一致 */
.container-withdrawal {
  .custom-nav-block {
    .van-bar {
      .van-nav-bar__content {
        .van-nav-bar__right {
          padding: 0 !important;

          .tit-right {
            display: inline-flex;
            align-items: center;
            height: 100%;
            padding: 0 16px;
            margin-left: 20px;
          }
        }
      }
    }
  }
}
</style>
